import apiClient from '@/lib/api-client';
import type { AppNotification, NotificationsListResponse } from '@/types/notification';

export const notificationService = {
  async list(options: { page?: number; limit?: number; unread?: boolean } = {}): Promise<NotificationsListResponse> {
    const res = await apiClient.get<{
      success: boolean;
      data: AppNotification[];
      unreadCount: number;
      pagination: { page: number; limit: number; total: number; totalPages: number };
    }>('/notifications', { params: options });
    return {
      notifications: res.data.data,
      unreadCount: res.data.unreadCount,
      pagination: res.data.pagination,
    };
  },

  async unreadCount(): Promise<number> {
    const res = await apiClient.get<{ success: boolean; data: { count: number } }>(
      '/notifications/unread-count'
    );
    return res.data.data.count;
  },

  async markRead(id: string): Promise<void> {
    await apiClient.patch(`/notifications/${id}/read`);
  },

  async markAllRead(): Promise<number> {
    const res = await apiClient.patch<{ success: boolean; data: { count: number } }>(
      '/notifications/read-all'
    );
    return res.data.data.count;
  },

  async deleteOne(id: string): Promise<void> {
    await apiClient.delete(`/notifications/${id}`);
  },
};
